/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import './ImageGalleryIRCCHARITY.css';
import WEEKLY_LECTURES1 from '../images/WEEKLY_LECTURES1.webp';
import WEEKLY_LECTURES2 from '../images/WEEKLY_LECTURES2.webp';
import WEEKLY_LECTURES3 from '../images/WEEKLY_LECTURES3.webp';
import WEEKLY_LECTURES4 from '../images/WEEKLY_LECTURES4.webp';
import WEEKLY_LECTURES5 from '../images/WEEKLY_LECTURES5.webp';
import WEEKLY_LECTURES6 from '../images/WEEKLY_LECTURES6.webp';

const ImageGalleryIRCCHARITY = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Memoize the imageList array
  const imageList = useMemo(() => [
    { id: 1, image: WEEKLY_LECTURES1 },
    { id: 2, image: WEEKLY_LECTURES2 },
    { id: 3, image: WEEKLY_LECTURES3 },
    { id: 4, image: WEEKLY_LECTURES4 },
    { id: 5, image: WEEKLY_LECTURES5 },
    { id: 6, image: WEEKLY_LECTURES6 },
  ], []);

  const openLightbox = (image, index) => {
    setSelectedImage(image);
    setCurrentIndex(index);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    setCurrentIndex(0);
  };

  // Memoize the navigation functions
  const goToPrevious = useCallback(() => {
    const newIndex = currentIndex === 0 ? imageList.length - 1 : currentIndex - 1;
    setSelectedImage(imageList[newIndex]);
    setCurrentIndex(newIndex);
  }, [currentIndex, imageList]);

  const goToNext = useCallback(() => {
    const newIndex = currentIndex === imageList.length - 1 ? 0 : currentIndex + 1;
    setSelectedImage(imageList[newIndex]);
    setCurrentIndex(newIndex);
  }, [currentIndex, imageList]);

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedImage) return;

      if (e.key === 'ArrowLeft') {
        goToPrevious();
      } else if (e.key === 'ArrowRight') {
        goToNext();
      } else if (e.key === 'Escape') {
        closeLightbox();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, currentIndex, goToNext, goToPrevious]);

  return (
    <section className="gallery-section">
      <div className="gallery-container">

        {/* Image Grid */}
        <div className="gallery-grid">
          {imageList.map((image, index) => (
            <div
              key={image.id}
              className="gallery-item"
              onClick={() => openLightbox(image, index)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={image.image}
                className="gallery-image"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div className="lightbox active" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeLightbox}>&times;</button>

            {/* Navigation Buttons */}
            <button className="nav-btn prev-btn" onClick={goToPrevious}>
              &#8249;
            </button>

            <button className="nav-btn next-btn" onClick={goToNext}>
              &#8250;
            </button>

            <img 
              src={selectedImage.image}
              className="lightbox-image" 
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default ImageGalleryIRCCHARITY;